module.exports = __webpack_public_path__ + "img/btn1.ad8ae7fa.png";